import "./Bethel.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/about/about";
import Services from "./pages/services/services";
import Vault from "./pages/vault/vault";
import Home from "./pages/home/home";
import Contact from "./pages/contact/contact";
import Announcements from "./pages/announcements/announcements";
import Menu from "./menu/Menu";
import ErrorPage from "./pages/error/errorPage";
import RefundPolicy from "./pages/refundPolicy/refundPolicy";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import ServiceTimes from "./pages/serviceTimes/serviceTimes";
import Events from "./pages/events/events";
import ScrollToTop from "./components/ScrollToTop";
import {
  homePath,
  aboutPath,
  servicePath,
  serviceTimesPath,
  eventsPath,
  contactPath,
  announcementsPath,
  privacyPolicyPath,
  refundPolicyPath,
  romanianPath,
  englishPath,
  dashboardPath,
  loginPath,
  pointsDashboardPath,
  pastServicesPath,
  serviceEditorPath,
  propertiesPath,
  goLivePath,
  givePath,
  EN,
  socialPath,
  urgentMessagesDashboardPath,
  congregantPortalPath,
  congregantPortalLoginPath,
  congregantPortalCallbackPath,
  congregantDonationsReimbursementsPath,
  mediaPath,
  vaultPath,
  bibleReadingPlanPath,
  bibleInAYearPath,
  biblePath,
  readingPlanPath,
} from "./constants";
import English from "./languageRouters/english";
import Romanian from "./languageRouters/romanian";
import ServiceContext from "./contexts/serviceContext";
import Dashboard from "./pages/privatePages/dashboard";
import Login from "./pages/privatePages/login";
import PointsDashboard from "./pages/privatePages/pointsDashboard";
import PastServices from "./pages/privatePages/pointsAddition/pastServices";
import ServiceEditor from "./pages/privatePages/pointsAddition/serviceEditor";
import Properties from "./pages/privatePages/properties/properties";
import GoLive from "./pages/privatePages/properties/goLive";
import Give from "./pages/donations/give";
import Social from "./pages/social/social";
import UrgentMessagesDashbaord from "./pages/privatePages/properties/urgentMessages/urgentMessages";
import PortalLogin from "./pages/congregantPortal/portalLogin";
import PortalDashboard from "./pages/congregantPortal/portalDashboard";
import PcoCallback from "./pages/congregantPortal/pcoCallback";
import PortalDonationsReimbursementsForm from "./pages/congregantPortal/portalDonationsReimbursementsForm";
import Gallery from "./pages/media/gallery";
import { ServiceEditorProvider } from "./contexts/serviceEditorContext";
import BiblePlan from "./pages/biblePlan/biblePlan";
import STRIPE from "./STRIPTEMP";
import Ezra from "./pages/tempPages/Ezra";
import Awana from "./pages/awana/Awana";
import CoffeeTournament from "./pages/tempPages/coffee/CoffeeTournament";
import IEMCheatSheet from "./pages/tempPages/iem/IEMCheatSheet";

const Bethel = () => {
  // USE STATES --------------------------------------------------------
  const [menuIsActive, setIsMenuActive] = useState(false);
  const [isHamburgerClicked, setIsHamburgerClicked] = useState(false);
  const [menuHeight, setMenuHeight] = useState(72); // matches --nav-height in index.css (desktop value)
  const [pageSizing, setPageSizing] = useState({
    footerSize: 0,
    menuSize: menuHeight,
  });
  const [serviceId, setServiceId] = useState("");
  const [serviceTimestamp, setServiceTimestamp] = useState("");
  const serviceValue = {
    serviceId,
    setServiceId,
    serviceTimestamp,
    setServiceTimestamp,
  };

  // -------------------------------------------------------------------

  /**
   * This is used whenever a menu button is clicked to ensure that after
   * a button click, the menu always closes
   */
  const closeMenu = () => {
    setIsMenuActive(false);
    setIsHamburgerClicked(false);
  };

  /**
   * Handles the menu hamburger toggle
   */
  const handleHamburger = () => {
    setIsMenuActive(menuIsActive ? false : true);
    setIsHamburgerClicked(isHamburgerClicked ? false : true);
  };

  /**
   * Sets the menu height retrieved from the menu component
   */
  const handleMenuHeight = (height) => {
    setMenuHeight(height);
    setPageSizing({
      footerSize: 0,
      menuSize: height,
    });
  };

  return (
    <BrowserRouter>
      <ServiceContext.Provider value={serviceValue}>
        <ScrollToTop />
        <div style={{ height: "100vh" }}>
          <Menu
            menuIsActive={menuIsActive}
            isHamburgerClicked={isHamburgerClicked}
            closeMenu={closeMenu}
            handleHamburger={handleHamburger}
            handleMenuHeight={handleMenuHeight}
          />
          <Routes>
            <Route path={homePath} exact element={<Home size={pageSizing} />} />
            <Route path={aboutPath} element={<About />} size={pageSizing} />
            <Route
              path={servicePath}
              element={<Services size={pageSizing} />}
            />
            <Route path={serviceTimesPath} element={<ServiceTimes />} />
            <Route path={eventsPath} element={<Events />} />
            <Route path={vaultPath} element={<Vault />} />
            <Route path={contactPath} element={<Contact size={pageSizing} />} />
            <Route path={givePath} element={<Give />} />
            <Route
              path={announcementsPath}
              element={<Announcements size={pageSizing} />}
            />
            <Route
              path={privacyPolicyPath}
              element={<PrivacyPolicy size={pageSizing} />}
            />
            <Route
              path={refundPolicyPath}
              element={<RefundPolicy size={pageSizing} />}
            />
            <Route path={dashboardPath} element={<Dashboard />} />
            <Route path={loginPath} element={<Login />} />
            <Route path={pointsDashboardPath} element={<PointsDashboard />} />
            <Route path={pastServicesPath} element={<PastServices />} />
            <Route
              path={serviceEditorPath}
              element={
                <ServiceEditorProvider>
                  <ServiceEditor />
                </ServiceEditorProvider>
              }
            />
            <Route path={propertiesPath} element={<Properties />} />
            <Route path={goLivePath} element={<GoLive />} />
            <Route path={socialPath} element={<Social />} />
            <Route
              path={urgentMessagesDashboardPath}
              element={<UrgentMessagesDashbaord />}
            />
            {/* Congregant portal - Planning Center login. The reimbursement
                form used to also be open, unauthenticated, at
                /reimbursementForm - it now only lives behind login here. */}
            <Route path={congregantPortalPath} element={<PortalDashboard />} />
            <Route path={congregantPortalLoginPath} element={<PortalLogin />} />
            <Route path={congregantPortalCallbackPath} element={<PcoCallback />} />
            <Route path={congregantDonationsReimbursementsPath} element={<PortalDonationsReimbursementsForm />} />
            <Route path={mediaPath} element={<Gallery />} />
            <Route path={romanianPath} element={<Romanian />} />
            <Route path={englishPath} element={<English />} />
            {/* This route is for the Bible reading plan that will be over in 2025. Remove this then. */}
            <Route path={bibleReadingPlanPath} element={<BiblePlan />} />
            <Route path={bibleInAYearPath} element={<BiblePlan />} />
            <Route path={biblePath} element={<BiblePlan />} />
            <Route path={readingPlanPath} element={<BiblePlan />} />
            <Route path="hidden_stripe" element={<STRIPE />} />{" "}
            {/* TODO: REMOVE THIS WHEN WE'RE SETTLED */}
            <Route path="Ezra" element={<Ezra />} />{" "}
            <Route path="Awana" element={<Awana />} />
            <Route path="Coffee" element={<CoffeeTournament /> } />
            <Route path="iem" element={<IEMCheatSheet />} />
            <Route path="inears" element={<IEMCheatSheet />} />
            <Route path="*" element={<ErrorPage size={pageSizing} />} />
          </Routes>
        </div>
      </ServiceContext.Provider>
    </BrowserRouter>
  );
};

export default Bethel;
